import { render, staticRenderFns } from "./NewContactPage.vue?vue&type=template&id=ffba801a&scoped=true"
import script from "./NewContactPage.vue?vue&type=script&lang=js"
export * from "./NewContactPage.vue?vue&type=script&lang=js"
import style0 from "./NewContactPage.vue?vue&type=style&index=0&id=ffba801a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffba801a",
  null
  
)

export default component.exports